import { FC } from 'react';
import classNames from 'classnames';

import WarningIcon from '../../assets/icons/warning.png';
import DangerIcon from '../../assets/icons/danger.png';
import InfoIcon from '../../assets/icons/info.png';

type MessageLevel = 'info' | 'warning' | 'danger';

export interface CheckMessage {
  message: string;
  level: MessageLevel;
}

interface Props {
  messages: CheckMessage[];
  className?: string;
}

const ICONS: Record<MessageLevel, string> = {
  warning: WarningIcon,
  danger: DangerIcon,
  info: InfoIcon,
};

export const CheckMessagesBlock: FC<Props> = ({ messages, className }) => {
  if (!messages.length) return null;

  return (
    <div className={classNames('space-y-[12px]', className)}>
      {messages.map(({ message, level }, idx) => (
        <div
          key={idx}
          className={classNames(
            'flex items-start gap-[30px] rounded-[16px] p-[12px] text-sm',
            {
              'bg-brand-9 bg-opacity-20 text-brand-1': level === 'warning',
              'bg-brand-8 bg-opacity-20 text-brand-1': level === 'danger',
              'bg-brand-5 bg-opacity-40 text-brand-1': level === 'info',
            }
          )}
        >
          <img src={ICONS[level]} alt={level} width={20} height={20} />
          <div>{message}</div>
        </div>
      ))}
    </div>
  );
};
